import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Hero from "@/components/sections/Hero";
import TrustBadges from "@/components/sections/TrustBadges";
import ProductsShowcase from "@/components/sections/ProductsShowcase";
import Transparency from "@/components/sections/Transparency";
import { BundleCard } from "@/components/BundleCard";
import { getBundles } from "@/lib/api";

export default function Home() {
  const [bundles, setBundles] = useState([]);

  useEffect(() => {
    getBundles().then(setBundles).catch(() => setBundles([]));
  }, []);

  return (
    <div>
      <Hero />
      <div className="relative z-20 mx-auto -mt-24 max-w-6xl px-4 sm:px-6 lg:px-8">
        <TrustBadges />
      </div>
      <ProductsShowcase />
      <Transparency />

      {/* Bundles — projects-style */}
      <section id="bundles-preview" className="relative py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
            <div className="max-w-2xl">
              <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">Curated together</span>
              <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">Premium bundles for every bench.</h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-600">Grouped research and educational sets, curated for value and ready to deploy.</p>
            </div>
            <Link to="/bundles"><Button variant="outline" className="border-slate-200 bg-transparent text-slate-700 hover:bg-slate-100 hover:text-slate-900">All bundles <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
          </motion.div>
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {bundles.map((b, i) => <BundleCard key={b.id} bundle={b} index={i} />)}
          </div>
        </div>
      </section>
    </div>
  );
}
